/**
 * Feature flags for the Studio Console.
 *
 * `demoControls` gates the facilitator-only day-stepper in the top bar. This is
 * a facilitator/prototype demo, so it defaults ON. It reads an optional
 * `VITE_DEMO_CONTROLS` env var so a build can force it off ('false'/'0'), but
 * when unset it stays on.
 */
function readDemoControls(): boolean {
  const raw = import.meta.env?.VITE_DEMO_CONTROLS as string | undefined;
  if (raw === undefined) return true;
  return raw !== 'false' && raw !== '0';
}

export const demoControls: boolean = readDemoControls();

/**
 * Gates the console's "Via HookChat pipeline" simulator harness (tv-isee):
 * the checkbox/hours-ago select, and simulating a customer reply on a real
 * HookChat thread. It hits a dev-only API route (`/_dev/hookchat/inbound`)
 * that only exists when the server runs with `ALLOW_DEV_ROUTES=true` — a
 * deployed build (e.g. staging, where `ALLOW_DEV_ROUTES=false`) must not
 * render it. Mirrors the same signal App.tsx uses to gate its dev-only
 * window hooks. A function (not a module-level constant) so tests can mock
 * it per case.
 */
export function hookchatDevHarnessEnabled(): boolean {
  return Boolean(import.meta.env.DEV);
}
